module.exports = __webpack_public_path__ + "static/media/18.06973f8c.jpg";